// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main__logo{
    margin: 2.5em auto 1.45em;
    width: 3em;
    height: auto; 
    transform: translateX(0.25em);
}
.main__titleMobile{
    text-align: center;
    font-weight: 500;
    font-size: 1.875em;
    line-height: 1.3666;
    margin-bottom: 0.85em;
}
.main__text{
    font-weight: 400;
    font-size: 0.875em;
    line-height: 1.286;
    text-align: center;
    margin: 0 auto;
    max-width: 20em;
    margin-bottom: 1.85em;
}
.main__text span{
    display: none;
}
.main__text p:not(:last-child){
    margin-bottom: 0.6em;
}
.main__btn{
    margin: 0 auto;
    width: 5.9em;
}
.frame__mainImages{
    transition: 0.3s padding;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow: hidden;
    padding-bottom: 3em;
    padding-top: 2em;
    margin-top: auto;
}
.frame:not(.frame--main) .frame__mainImages{
    padding: 0;
    height: 0;
}
.frame__mainImage{ 
    overflow: hidden; 
}
.frame__mainImage--1{
    width: 12.25em;
    transform: rotate(4.78deg) translateX(2.5em);
}
.frame__mainImage--2{
    width: 11.6875em;
    transform: rotate(-6.15deg) translate(1.4em,2.55em);
}
.frame__mainImage--3{
    width: 11.6875em;
    transform: rotate(-15.15deg) translate(-1.9em,2.95em);
}
.main__title{
    display: none;
    text-align: center;
    font-weight: 700;
    font-size: 3em;
    line-height: 1.208;
    margin-top: 8.45rem;
    margin-bottom: 1.7rem;
}
.frame__mainImageWrapper{
    display: block;
}
.frame__mainImageWrapper--4,
.frame__mainImageWrapper--5{
    display: none;
}
.frame__mainImage .tips__top,
.frame__mainImage .tips__bottom{
    font-size: 1.06em;
} 
@media(min-width: 100vh){
    .main__logo,
    .main__titleMobile{
        display: none;
    }
    .main__title{
        display: block;
    }
    .main__text{
        font-size: 0.9375em;
        max-width: 37em;
        line-height: 1.3333;
        margin-bottom: 2.65em;
    }
    .main__text span{
        display: inline;
    }
    .main__text p:not(:last-child){
        margin-bottom: 1.3em;
    }
    .main__text p:last-child{
        max-width: 25em;
        margin: 0 auto;
    }
    .main__btn{
        width: 9.6875em;  
    }
    .frame__mainImages{
        padding: 0;
        margin: 0;
        overflow: inherit;
        --var-margin-k: 1;
    }
    .frame:not(.frame--main) .frame__mainImages{
        --var-margin-k: 3;
        pointer-events: none;
        animation: fadeOut 4s linear 2s normal infinite;   
    }
    .frame__mainImageWrapper{
        position: absolute;
        left: 50%;
        top: 0;
        transition: 1.3s margin;
    }
    .frame__mainImage{
        transition: 0.3s transform;
    }
    .frame__mainImageWrapper--4,
    .frame__mainImageWrapper--5{
        display: block;
    }
    .frame__mainImageWrapper--1{
        margin-top: calc(var(--var-margin-k) * 7.7em);
        margin-left: calc(var(--var-margin-k) * 27.7em);
        z-index: 2;
    }
    .frame.frame--main .frame__mainImageWrapper--1{  
        /*animation: mainImage 4s linear 0s normal infinite;   */   
    }
    .frame__mainImage--1{
        width: 16.06em;
        transform: rotate(18.1deg);
    }
    .frame__mainImageWrapper--1:hover .frame__mainImage--1{
        transform: scale(1.1) rotate(18.1deg);
    }
    .frame__mainImageWrapper--2{
        margin-top: calc(var(--var-margin-k) * 26.7em);
        margin-left: calc(var(--var-margin-k) * -38em);
        z-index: 2;
    }
    .frame.frame--main .frame__mainImageWrapper--2{    
        /*animation: mainImage 4s linear 0.2s normal infinite; */   
    }
    .frame__mainImage--2{
        width: 16.06em;
        transform: rotate(-10.62deg);
    }
    .frame__mainImageWrapper--2:hover .frame__mainImage--2{
        transform: scale(1.1) rotate(-10.62deg);    
    }   
    .frame__mainImageWrapper--3{
        margin-top: calc(var(--var-margin-k) * 9em);
        margin-left: calc(var(--var-margin-k) * -48.6em); 
    }
    .frame.frame--main .frame__mainImageWrapper--3{  
        /*animation: mainImage 4s linear 0.4s normal infinite;     */ 
    }
    .frame__mainImage--3{
        width: 16.06em;
        transform: rotate(12.18deg);
    }
    .frame__mainImageWrapper--3:hover .frame__mainImage--3{
        transform: scale(1.1) rotate(12.18deg);
    }
    .frame__mainImageWrapper--4{
        margin-top: calc(var(--var-margin-k) * 41.9em);
        margin-left: calc(var(--var-margin-k) * -22em); 
    }
    .frame.frame--main .frame__mainImageWrapper--4{     
        /*animation: mainImage 4s linear 0.6s normal infinite;  */ 
    }
    .frame__mainImage--4{
        width: 16.06em;
        transform: rotate(9.25deg);
    }
    .frame__mainImageWrapper--4:hover .frame__mainImage--4{
        transform: scale(1.1) rotate(9.25deg);
    }
    .frame__mainImageWrapper--5{
        margin-top: calc(var(--var-margin-k) * 34.5em);
        margin-left: calc(var(--var-margin-k) * 22.1em); 
    }
    .frame.frame--main .frame__mainImageWrapper--5{ 
        /*animation: mainImage 4s linear 0.8s normal infinite;       */
    }
    .frame__mainImage--5{
        width: 16.06em;
        transform: rotate(-12.46deg);
    }
    .frame__mainImageWrapper--5:hover .frame__mainImage--5{
        transform: scale(1.1) rotate(-12.46deg);
    }
    .frame__mainImage .tips__top, .frame__mainImage .tips__bottom {
        font-size: 1.4em;
    }
}

@keyframes mainImage {
  0% {
    transform: translate(0,0);
  } 
  12.5% {
    transform: translate(0.5em, -0.5em);
  }
  25% {
    transform: translate(-0.5em, -0.5em);
  } 
  50% {
    transform: translate(-0.5em, 0.5em);
  } 
  65% {
    transform: translate(0.5em, 0.5em);
  }
  80% {
    transform: translate(0.5em, -0.5em);
  }
  100% {
    transform: translate(0,0);
  }
}
@keyframes fadeOut {
  0% {
    opacity: 0;
  }  
  100% {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/Main/main.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,6BAA6B;AACjC;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,cAAc;IACd,YAAY;AAChB;AACA;IACI,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,SAAS;AACb;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,4CAA4C;AAChD;AACA;IACI,gBAAgB;IAChB,mDAAmD;AACvD;AACA;IACI,gBAAgB;IAChB,qDAAqD;AACzD;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;;IAEI,aAAa;AACjB;AACA;;IAEI,iBAAiB;AACrB;AACA;IACI;;QAEI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,mBAAmB;QACnB,eAAe;QACf,mBAAmB;QACnB,qBAAqB;IACzB;IACA;QACI,eAAe;IACnB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,eAAe;QACf,cAAc;IAClB;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;QACV,SAAS;QACT,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,+CAA+C;IACnD;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,MAAM;QACN,uBAAuB;IAC3B;IACA;QACI,0BAA0B;IAC9B;IACA;;QAEI,cAAc;IAClB;IACA;QACI,6CAA6C;QAC7C,+CAA+C;QAC/C,UAAU;IACd;IACA;QACI,wDAAwD;IAC5D;IACA;QACI,cAAc;QACd,0BAA0B;IAC9B;IACA;QACI,qCAAqC;IACzC;IACA;QACI,8CAA8C;QAC9C,8CAA8C;QAC9C,UAAU;IACd;IACA;QACI,wDAAwD;IAC5D;IACA;QACI,cAAc;QACd,4BAA4B;IAChC;IACA;QACI,uCAAuC;IAC3C;IACA;QACI,2CAA2C;QAC3C,gDAAgD;IACpD;IACA;QACI,4DAA4D;IAChE;IACA;QACI,cAAc;QACd,2BAA2B;IAC/B;IACA;QACI,sCAAsC;IAC1C;IACA;QACI,8CAA8C;QAC9C,8CAA8C;IAClD;IACA;QACI,yDAAyD;IAC7D;IACA;QACI,cAAc;QACd,0BAA0B;IAC9B;IACA;QACI,qCAAqC;IACzC;IACA;QACI,8CAA8C;QAC9C,+CAA+C;IACnD;IACA;QACI,8DAA8D;IAClE;IACA;QACI,cAAc;QACd,4BAA4B;IAChC;IACA;QACI,uCAAuC;IAC3C;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".main__logo{\n    margin: 2.5em auto 1.45em;\n    width: 3em;\n    height: auto; \n    transform: translateX(0.25em);\n}\n.main__titleMobile{\n    text-align: center;\n    font-weight: 500;\n    font-size: 1.875em;\n    line-height: 1.3666;\n    margin-bottom: 0.85em;\n}\n.main__text{\n    font-weight: 400;\n    font-size: 0.875em;\n    line-height: 1.286;\n    text-align: center;\n    margin: 0 auto;\n    max-width: 20em;\n    margin-bottom: 1.85em;\n}\n.main__text span{\n    display: none;\n}\n.main__text p:not(:last-child){\n    margin-bottom: 0.6em;\n}\n.main__btn{\n    margin: 0 auto;\n    width: 5.9em;\n}\n.frame__mainImages{\n    transition: 0.3s padding;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    overflow: hidden;\n    padding-bottom: 3em;\n    padding-top: 2em;\n    margin-top: auto;\n}\n.frame:not(.frame--main) .frame__mainImages{\n    padding: 0;\n    height: 0;\n}\n.frame__mainImage{ \n    overflow: hidden; \n}\n.frame__mainImage--1{\n    width: 12.25em;\n    transform: rotate(4.78deg) translateX(2.5em);\n}\n.frame__mainImage--2{\n    width: 11.6875em;\n    transform: rotate(-6.15deg) translate(1.4em,2.55em);\n}\n.frame__mainImage--3{\n    width: 11.6875em;\n    transform: rotate(-15.15deg) translate(-1.9em,2.95em);\n}\n.main__title{\n    display: none;\n    text-align: center;\n    font-weight: 700;\n    font-size: 3em;\n    line-height: 1.208;\n    margin-top: 8.45rem;\n    margin-bottom: 1.7rem;\n}\n.frame__mainImageWrapper{\n    display: block;\n}\n.frame__mainImageWrapper--4,\n.frame__mainImageWrapper--5{\n    display: none;\n}\n.frame__mainImage .tips__top,\n.frame__mainImage .tips__bottom{\n    font-size: 1.06em;\n} \n@media(min-width: 100vh){\n    .main__logo,\n    .main__titleMobile{\n        display: none;\n    }\n    .main__title{\n        display: block;\n    }\n    .main__text{\n        font-size: 0.9375em;\n        max-width: 37em;\n        line-height: 1.3333;\n        margin-bottom: 2.65em;\n    }\n    .main__text span{\n        display: inline;\n    }\n    .main__text p:not(:last-child){\n        margin-bottom: 1.3em;\n    }\n    .main__text p:last-child{\n        max-width: 25em;\n        margin: 0 auto;\n    }\n    .main__btn{\n        width: 9.6875em;  \n    }\n    .frame__mainImages{\n        padding: 0;\n        margin: 0;\n        overflow: inherit;\n        --var-margin-k: 1;\n    }\n    .frame:not(.frame--main) .frame__mainImages{\n        --var-margin-k: 3;\n        pointer-events: none;\n        animation: fadeOut 4s linear 2s normal infinite;   \n    }\n    .frame__mainImageWrapper{\n        position: absolute;\n        left: 50%;\n        top: 0;\n        transition: 1.3s margin;\n    }\n    .frame__mainImage{\n        transition: 0.3s transform;\n    }\n    .frame__mainImageWrapper--4,\n    .frame__mainImageWrapper--5{\n        display: block;\n    }\n    .frame__mainImageWrapper--1{\n        margin-top: calc(var(--var-margin-k) * 7.7em);\n        margin-left: calc(var(--var-margin-k) * 27.7em);\n        z-index: 2;\n    }\n    .frame.frame--main .frame__mainImageWrapper--1{  \n        /*animation: mainImage 4s linear 0s normal infinite;   */   \n    }\n    .frame__mainImage--1{\n        width: 16.06em;\n        transform: rotate(18.1deg);\n    }\n    .frame__mainImageWrapper--1:hover .frame__mainImage--1{\n        transform: scale(1.1) rotate(18.1deg);\n    }\n    .frame__mainImageWrapper--2{\n        margin-top: calc(var(--var-margin-k) * 26.7em);\n        margin-left: calc(var(--var-margin-k) * -38em);\n        z-index: 2;\n    }\n    .frame.frame--main .frame__mainImageWrapper--2{    \n        /*animation: mainImage 4s linear 0.2s normal infinite; */   \n    }\n    .frame__mainImage--2{\n        width: 16.06em;\n        transform: rotate(-10.62deg);\n    }\n    .frame__mainImageWrapper--2:hover .frame__mainImage--2{\n        transform: scale(1.1) rotate(-10.62deg);    \n    }   \n    .frame__mainImageWrapper--3{\n        margin-top: calc(var(--var-margin-k) * 9em);\n        margin-left: calc(var(--var-margin-k) * -48.6em); \n    }\n    .frame.frame--main .frame__mainImageWrapper--3{  \n        /*animation: mainImage 4s linear 0.4s normal infinite;     */ \n    }\n    .frame__mainImage--3{\n        width: 16.06em;\n        transform: rotate(12.18deg);\n    }\n    .frame__mainImageWrapper--3:hover .frame__mainImage--3{\n        transform: scale(1.1) rotate(12.18deg);\n    }\n    .frame__mainImageWrapper--4{\n        margin-top: calc(var(--var-margin-k) * 41.9em);\n        margin-left: calc(var(--var-margin-k) * -22em); \n    }\n    .frame.frame--main .frame__mainImageWrapper--4{     \n        /*animation: mainImage 4s linear 0.6s normal infinite;  */ \n    }\n    .frame__mainImage--4{\n        width: 16.06em;\n        transform: rotate(9.25deg);\n    }\n    .frame__mainImageWrapper--4:hover .frame__mainImage--4{\n        transform: scale(1.1) rotate(9.25deg);\n    }\n    .frame__mainImageWrapper--5{\n        margin-top: calc(var(--var-margin-k) * 34.5em);\n        margin-left: calc(var(--var-margin-k) * 22.1em); \n    }\n    .frame.frame--main .frame__mainImageWrapper--5{ \n        /*animation: mainImage 4s linear 0.8s normal infinite;       */\n    }\n    .frame__mainImage--5{\n        width: 16.06em;\n        transform: rotate(-12.46deg);\n    }\n    .frame__mainImageWrapper--5:hover .frame__mainImage--5{\n        transform: scale(1.1) rotate(-12.46deg);\n    }\n    .frame__mainImage .tips__top, .frame__mainImage .tips__bottom {\n        font-size: 1.4em;\n    }\n}\n\n@keyframes mainImage {\n  0% {\n    transform: translate(0,0);\n  } \n  12.5% {\n    transform: translate(0.5em, -0.5em);\n  }\n  25% {\n    transform: translate(-0.5em, -0.5em);\n  } \n  50% {\n    transform: translate(-0.5em, 0.5em);\n  } \n  65% {\n    transform: translate(0.5em, 0.5em);\n  }\n  80% {\n    transform: translate(0.5em, -0.5em);\n  }\n  100% {\n    transform: translate(0,0);\n  }\n}\n@keyframes fadeOut {\n  0% {\n    opacity: 0;\n  }  \n  100% {\n    opacity: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
